import { request } from '../request';

// ==========================================
// 前台/轮播图 API
// ==========================================

// 用于在途请求去重 (In-flight request deduplication)，防止 React 严格模式或双重挂载引发重复网络请求
const inFlightRequests = new Map<string, Promise<Api.Banner.BannerResponse[]>>();

/**
 * 获取前台轮播图列表
 * GET /banners
 *
 * @param params 查询参数 (包含 type 轮播图类型)
 * @returns 轮播图列表
 */
export function fetchBanners(params?: Api.Banner.QueryBannersParams) {
  const cacheKey = params?.type ? `type:${params.type}` : '__ALL__';

  // 若当前相同 type 已有在途请求，直接复用已有 Promise
  if (inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey)!;
  }

  const promise = request<Api.Banner.BannerResponse[]>({
    url: '/banners',
    method: 'get',
    params
  }).finally(() => {
    // 请求响应后保留微小时间窗口，防页面初始化双重挂载造成的重复请求
    setTimeout(() => {
      inFlightRequests.delete(cacheKey);
    }, 300);
  });

  inFlightRequests.set(cacheKey, promise);
  return promise;
}
